import { createTopic, ConfigActions } from '../lib';
import { z } from 'zod';

const marketplaceConsumableInterfaceNavigatedEventSchema = z.object({
  entityUrn: z.string().describe('The URN of the consumable interface.'),
  path: z
    .string()
    .describe(
      'The navigated path to the consumable interface in the marketplace.',
    ),
});

export type MarketplaceConsumableInterfaceNavigatedEvent = z.infer<
  typeof marketplaceConsumableInterfaceNavigatedEventSchema
>;

export const marketplaceConsumableInterfaceNavigatedTopic =
  createTopic<MarketplaceConsumableInterfaceNavigatedEvent>(
    {
      namespace: 'marketplace',
      name: 'consumable-interface-navigated',
      description:
        'User navigated to a consumable interface in the marketplace.',
    },
    marketplaceConsumableInterfaceNavigatedEventSchema,
    s => [{ action: ConfigActions.HASH, path: s.entityUrn }],
  );
